module.exports = __webpack_public_path__ + "static/media/S (110).9ad35a55.jpg";